import { render } from "./PreloadedImage.vue?vue&type=template&id=4740073d"
import script from "./PreloadedImage.vue?vue&type=script&lang=js"
export * from "./PreloadedImage.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Cadpeople\\arla-afi-3-segments-launch\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__